import { useEffect, useCallback } from 'react';
import { selectors, getAll, addItem, updateItem, deleteItem } from '../../../redux/companyTaxes';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

export default function useCompanyTax() {
    const dispatch = useDispatch();
    const reduxState = useSelector(state => state.companyTaxes);
    const items = selectors.selectAll(reduxState);
    const loading = reduxState.loading;

    useEffect(() => {
        dispatch(getAll());
    }, [dispatch]);

    const save = useCallback((item) => {
        const updateCall = async () => {
            if (item.tax_id) {
                await dispatch(updateItem({ id: item.tax_id, ...item }));
            } else {
                await dispatch(addItem(item));
            }
            toast.success("Saved successfully");
        };

        updateCall();
    }, [dispatch]);

    const remove = useCallback((item) => {
        const deleteCall = async () => {
            await dispatch(deleteItem(item));
            toast.success("Deleted successfully");
        };

        deleteCall();
    }, [dispatch]);

    return [
        items,
        loading,
        save,
        remove
    ];
};
